export default __webpack_public_path__ + "static/media/Group 31(1).647795f9.svg";